module.exports = __webpack_public_path__ + "HANMUClogo.6aa1e062.png";